import React, { useCallback, useEffect, useState } from 'react';
import { useProductScanner, Product } from '../hooks/useProductScanner';
const NAMES = ['María', 'Carlos', 'Valentina', 'Diego', 'Camila', 'Andrés', 'Lucía', 'Mateo', 'Sofía', 'Sebastián', 'Paula', 'Nicolás', 'Florencia', 'Tomás', 'Carolina'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Bogotá', 'Medellín', 'Lima', 'Santiago', 'Montevideo', 'CDMX', 'Guadalajara', 'Quito'];
interface ToastData {
  name: string;
  city: string;
  timeAgo: number;
  product: Product;
}
export function RecentPurchaseToast() {
  const products = useProductScanner();
  const [isVisible, setIsVisible] = useState(false);
  const [toastData, setToastData] = useState<ToastData | null>(null);
  const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
  const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
  const generateToastData = useCallback(() => {
    if (products.length === 0) return null;
    return {
      name: getRandomItem(NAMES),
      city: getRandomItem(CITIES),
      timeAgo: getRandomInt(1, 15),
      product: getRandomItem(products)
    };
  }, [products]);
  useEffect(() => {
    if (products.length === 0) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const scheduleNextToast = (isFirst: boolean = false) => {
      // First toast appears after 8-12s, subsequent ones after 15-25s
      const delay = isFirst ? getRandomInt(8000, 12000) : getRandomInt(15000, 25000);
      showTimeout = setTimeout(() => {
        const newData = generateToastData();
        if (newData) {
          setToastData(newData);
          setIsVisible(true);
          // Hide after 5 seconds
          hideTimeout = setTimeout(() => {
            setIsVisible(false);
            // Schedule the next one after hiding
            scheduleNextToast(false);
          }, 5000);
        } else {
          scheduleNextToast(false);
        }
      }, delay);
    };
    scheduleNextToast(true);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [products, generateToastData]);
  if (!toastData) return null;
  return <div className={`fixed bottom-3 left-3 right-3 md:right-auto md:left-5 md:bottom-5 z-50 transition-all duration-500 ease-out ${isVisible ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-[120%] opacity-0 pointer-events-none'}`} data-id="element-257" data-mp="kgtfgxmb1os">
      <div className="bg-[#150025]/95 backdrop-blur-sm border border-[rgba(194,0,111,0.3)] rounded-lg md:rounded-xl py-2 px-3 md:py-3 md:px-4 md:max-w-[320px] shadow-[0_8px_30px_rgba(0,0,0,0.5),0_0_20px_rgba(194,0,111,0.15)] relative overflow-hidden" data-id="element-258" data-mp="341qn7t5j6xcf">
        <div className="flex items-center gap-2.5 md:gap-3" data-id="element-259" data-mp="2gceib5h8lbfx">
          {/* Thumbnail */}
          <div className="shrink-0" data-id="element-260" data-mp="2lapqzcvspfwk">
            <img src={toastData.product.thumbnailUrl} alt={toastData.product.title} className="w-8 h-8 md:w-10 md:h-10 rounded-md object-cover border border-white/10" data-id="element-261" data-mp="2l9od70neafb5" />
          </div>

          {/* Content — compact single flow */}
          <div className="flex-1 min-w-0" data-id="element-262" data-mp="te3v4676tqim">
            <p className="text-white/80 text-[0.7rem] md:text-xs leading-tight truncate" data-id="element-263" data-mp="th9hhdofmean">
              <span className="font-heading font-bold text-white" data-id="element-264" data-mp="oi6dzxo3og4s">
                {toastData.name}
              </span>
              {' de '}
              {toastData.city}
              {' compró'}
            </p>
            <div className="flex items-center justify-between gap-2 mt-0.5" data-id="element-265" data-mp="eofrgybjafrq">
              <span className="text-magenta-bright font-heading font-bold text-[0.75rem] md:text-sm truncate" data-id="element-266" data-mp="aox7c4rje8py">
                {toastData.product.title}
              </span>
              <span className="text-gold font-heading font-bold text-[0.75rem] md:text-sm shrink-0" data-id="element-267" data-mp="p6cu32z7tpv">
                {toastData.product.priceText}
              </span>
            </div>
            <div className="flex items-center justify-between mt-0.5" data-id="element-268" data-mp="1vte5ba84w4zg">
              <span className="text-green-400 text-[0.6rem] md:text-[0.7rem] font-medium flex items-center gap-0.5" data-id="element-269" data-mp="20shbixzuoh90">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-270" data-mp="1m4e1ndioslex">
                  <polyline points="20 6 9 17 4 12" data-id="element-271" data-mp="13506wtd4v6nd"></polyline>
                </svg>
                Verificada
              </span>
              <span className="text-white/30 text-[0.6rem] md:text-[0.65rem]" data-id="element-272" data-mp="183a3n8eiafb3">
                hace {toastData.timeAgo} min
              </span>
            </div>
          </div>

          {/* Close button */}
          <button type="button" onClick={e => {
          e.stopPropagation();
          setIsVisible(false);
        }} className="shrink-0 text-white/30 hover:text-white/60 transition-colors p-0.5" aria-label="Cerrar" data-id="element-273" data-mp="32h1lgv6zo5hm">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-274" data-mp="10ku62ujtfwb1">
              <line x1="18" y1="6" x2="6" y2="18" data-id="element-275" data-mp="15jdpooaxsw08"></line>
              <line x1="6" y1="6" x2="18" y2="18" data-id="element-276" data-mp="1jjy65dtdqfqk"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>;
}